import React from "react";
import "./style.css";
import downloadWhite from "images/downloadWhite.svg";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  FormControl,
  FormControlLabel,
  Typography,
  RadioGroup,
  Radio,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
} from "@material-ui/core";

const DownloadPopup = (props) => {
  const handleClose = () => {
    props.setOpenDownloadModal(false);
    props.setDownloadType(null);
  };
  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="xs"
        open={props.openDownloadModal}
      >
        <MuiDialogTitle disableTypography id="dialog-gstr2a2b-title">
          <div className="dialog-gstr2a2b-div">
            <div></div>
            <Typography variant="h6">Download</Typography>
            <CloseIcon onClick={handleClose} id="dialog-closeIcon" />
          </div>
        </MuiDialogTitle>

        <MuiDialogContent dividers>
          <div className="dialog-gstr2a2b-div">
            <FormControl id="dialog-gstr2a2b-content">
              <RadioGroup
                aria-label="download"
                name="download"
                onChange={props.onChangeRadio}
              >
                <div class="col-md-12">
                  <FormControlLabel
                    value="gstinWise"
                    control={<Radio />}
                    label="GSTIN-wise"
                  />
                </div>
                <div class="col-md-12">
                  <FormControlLabel
                    value="consolidated"
                    control={<Radio />}
                    label="Consolidated"
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </div>

          <div className="gstr2a2b-flex-center">
            <Button
              onClick={props.handleDownload}
              variant="contained"
              color="primary"
              id="dialog-gstr2a2b-button"
            >
              <img
                src={downloadWhite}
                alt="Download"
                id="dialog-gstr2a2b-downloadImg"
              />
              Download
            </Button>
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default DownloadPopup;
